import { put, takeLatest, call } from "redux-saga/effects";
import { showNotification } from "../../utils/CommonFunctions";
import ACTIONS from "./RoleActionTypes";
import AppUrl from "../../config/AppUrl";
import axios from "axios";

const getAllRolesRequest = (params) => {
  return axios({
    method: "GET",
    url: `${AppUrl.ROLES_URL}`,
  });
};
const getOneRoleRequest = (params) => {
  return axios({
    method: "GET",
    url: `${AppUrl.ROLES_URL}/${params._id}`,
  });
};

const addRoleRequest = (data) => {
  return axios({
    method: "POST",
    url: `${AppUrl.ROLES_URL}`,
    data,
  });
};

const updateRoleRequest = (data) => {
  return axios({
    method: "PUT",
    url: `${AppUrl.ROLES_URL}/${data._id}`,
    data,
  });
};

function* getAllRoles(action) {
  try {
    let response = yield call(getAllRolesRequest);
    let _data = response?.data;

    if (_data?.meta?.success !== true || _data?.meta?.status !== 200) {
      showNotification("error", _data?.meta?.message);
      yield put({ type: ACTIONS.FETCH_ALL_ROLES_FAILURE, payload: _data });
    } else {
      yield put({ type: ACTIONS.FETCH_ALL_ROLES_SUCCESS, payload: _data });
    }
  } catch (error) {
    console.log("fetch allRoles error", error);
  }
}

function* getRole(action) {
  try {
    let response = yield call(getOneRoleRequest, action.payload);
    let _data = response?.data;

    if (_data?.meta?.success !== true || _data?.meta?.status !== 200) {
      yield put({ type: ACTIONS.GET_ONE_ROLE_FAILURE, payload: _data });
    } else {
      yield put({ type: ACTIONS.GET_ONE_ROLE_SUCCESS, payload: _data.data });
    }
  } catch (error) {
    console.log("fetch role error", error);
  }
}

function* addRole(action) {
  try {
    let response = yield call(addRoleRequest, action.payload);
    let _data = response?.data;
    if (_data?.meta?.success !== true || _data?.meta?.status !== 200) {
      showNotification("error", _data?.meta?.message);
      yield put({ type: ACTIONS.ADD_ROLE_FAILURE, payload: _data?.meta });
    } else {
      yield put({ type: ACTIONS.ADD_ROLE_SUCCESS, payload: _data?.data });
      showNotification("success", _data?.meta?.message);
    }
  } catch (error) {
    console.log("add role room error", error);
  }
}

function* updateRole(action) {
  try {
    let response = yield call(updateRoleRequest, action.payload);
    let _data = response?.data;
    if (_data?.meta?.success !== true || _data?.meta?.status !== 200) {
      showNotification("error", _data?.meta?.message);
      yield put({
        type: ACTIONS.UPDATE_ROLE_FAILURE,
        payload: _data,
      });
    } else {
      yield put({
        type: ACTIONS.UPDATE_ROLE_SUCCESS,
        payload: _data?.data,
      });
      showNotification("success", _data?.meta?.message);
    }
  } catch (error) {
    console.log("update role error", error);
  }
}

// ACTION WATCHER
export default function* roleSaga() {
  yield takeLatest(ACTIONS.FETCH_ALL_ROLES, getAllRoles);
  yield takeLatest(ACTIONS.GET_ONE_ROLE, getRole);
  yield takeLatest(ACTIONS.ADD_ROLE, addRole);
  yield takeLatest(ACTIONS.UPDATE_ROLE, updateRole);
}
